import styles from './CheckboxButton.module.scss';
import React from 'react'
import { Radio, RadioProps } from 'antd';

export type CheckboxButtonProps = {
    title: string;
    badgeValue: string;
} & RadioProps

function CheckboxButton(props: CheckboxButtonProps) {
    const { badgeValue, title, ...otherProps } = props;

    return (
        <div className={styles.checkboxBtn}>
            <Radio  {...otherProps}>{title}</Radio>
            <div>{badgeValue}</div>
        </div>
    )
}

export default CheckboxButton